require('./ProgramStatistics.scss');

const b = require('app/www/libs/b')('program-statistics');

const {formatHighDigits} = require('app/common/libs/regexp');

const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');

const Global = require('app/www/components/blocks/Global/Global');
const Link = require('app/www/components/blocks/Link/Link');

const {GOOD_RATING, MIN_VOTES} = require('app/www/constants/programRating');

class ProgramStatistics extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    render() {
        const {i18n, programCoId, reviews, awards} = this.props;
        const {rate, votes} = this.props.rating;

        const ratingMod = {
            'rating-good': rate >= GOOD_RATING,
        };

        const votesFormatted = formatHighDigits(votes);

        const linkProps = {
            url: Global.kinopoiskProgramUrl(programCoId),
            attrs: {
                target: '_blank',
            },
        };

        const linkReviewsProps = Object.assign({}, linkProps, {
            url: Global.kinopoiskProgramReviewsUrl(programCoId),
        });

        const linkAwardsProps = Object.assign({}, linkProps, {
            url: Global.kinopoiskProgramAwardsUrl(programCoId),
        });

        const reviewWidth = this._calculateReviewsWidth();

        const reviewsGoodStyle = {
            width: `${reviewWidth.good}%`,
        };

        const reviewsNeutralStyle = {
            width: `${reviewWidth.neutral}%`,
        };

        const reviewsBadStyle = {
            width: `${reviewWidth.bad}%`,
        };

        return (
            <div className={b()}>
                {votes >= MIN_VOTES && (
                    <Link className={b('item', ratingMod)} {...linkProps}>
                        <div itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating">
                            <div className={b('title')}>
                                {i18n.get('program-statistics.rating')}
                            </div>
                            <div itemProp="ratingValue" className={b('value')}>{rate}</div>
                            <div className={b('details')}>{votesFormatted}</div>
                            <meta itemProp="bestRating" content="10" />
                            <meta itemProp="worstRating" content="0" />
                            <meta itemProp="ratingCount" content={votes} />
                        </div>
                    </Link>
                )}
                {reviews && reviews.total > 0 && (
                    <Link className={b('item', {reviews: true})} {...linkReviewsProps}>
                        <div className={b('title')}>
                            {i18n.get('program-statistics.reviews')}
                        </div>
                        <div className={b('value')}>{reviews.total}</div>
                        <div className={b('reviews-wrapper')}>
                            {reviews.good > 0 && (
                                <span className={b('reviews', {good: true})} style={reviewsGoodStyle} />
                            )}
                            {reviews.neutral > 0 && (
                                <span className={b('reviews', {neutral: true})} style={reviewsNeutralStyle} />
                            )}
                            {reviews.bad > 0 && (
                                <span className={b('reviews', {bad: true})} style={reviewsBadStyle} />
                            )}
                        </div>
                    </Link>
                )}
                {awards.total > 0 && (
                    <Link className={b('item', {awards: true})} {...linkAwardsProps}>
                        <div className={b('title')}>
                            {i18n.get('program-statistics.awards')}
                        </div>
                        <div className={b('value')}>{awards.total}</div>
                        <div className={b('details')}>{awards.titles.join(', ')}</div>
                    </Link>
                )}
            </div>
        );
    }

    /**
     * Рассчитываем ширину шкал рецензий
     * @returns {Object}
     * @private
     */
    _calculateReviewsWidth() {
        const {reviews} = this.props;
        const width = {};

        if (reviews) {
            Object.keys(reviews).forEach(key => {
                width[key] = Math.floor((reviews[key] / reviews.total) * 100);
            });
        }

        return width;
    }

}

ProgramStatistics.propTypes = {
    rating: PropTypes.object,
    reviews: PropTypes.object,
    awards: PropTypes.shape({
        total: PropTypes.number,
        titles: PropTypes.arrayOf(PropTypes.string),
    }),
};

module.exports = withI18n(ProgramStatistics);
